import { Config } from "final-form"
import { defineComponent } from 'vue'

import { Location } from "@skinsoft/types"
import { reactiveVueMixin } from "@skinsoft/reactive-vue"
import { LocationSelectorPopup } from "@skinsoft/entity-ui/src/location/location-selector-popup"
import { Field, Form, LocalizedString, ThesaurusTermChooser } from "@skinsoft/ui"

export const CreateContainerForm = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sLocationSelectorPopup: LocationSelectorPopup,
        sLocalizedString: LocalizedString,
        sThesaurusTermChooser: ThesaurusTermChooser,
    },
    props: ['onSubmit', 'initialValues', 'motives'],
    template: require('./create-container-form.html'),
    data() {
        return {
            location: null as Location | null,
        }
    },
    methods: {
        onLocationSelected(locationEvent) {
            this.location = locationEvent.location
            ;(this.$refs.location as InstanceType<typeof Field>).$emit('change')
            const form = (this.$refs.form as InstanceType<typeof Form>).form;
            form.change('location', locationEvent.location)
            form.change('locationName', this.formatLocationInField(locationEvent.location))
            form.mutators.setFieldTouched('locationName', true)

        },
        openPopup() {
            (this.$refs.locationPopup as InstanceType<typeof LocationSelectorPopup>).open()
        },
        formatLocationInField(location) {
            return location.genericEntityTitle.translatedString[this.getAppLocale()]
        },
    },
})
